/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataModule" />
import { AnyAction, ReducersMapObject } from "redux";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ITfsPageDataAwareState } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts";
import { tfsPageDataReducer } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataReducer";
import { tfsPageDataSaga } from "Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataSaga";

export function getTfsPageDataModule(): ISagaModule<ITfsPageDataAwareState> {
    const reducerMap: ReducersMapObject<ITfsPageDataAwareState, AnyAction> = {
        tfsPageData: tfsPageDataReducer
    };

    return {
        id: "tfspagedata",
        reducerMap,
        sagas: [tfsPageDataSaga]
    };
}
